
import * as Price from "./price";

const frequencyEls = document.querySelectorAll(".order-content [name=frequency]");
const frequencyMobileCheckEl = document.querySelector(".order-content #year-month-checkbox");
const switchMobileLabelEls = document.querySelectorAll(".order-content .period-switcher__switch-wrap-mobile .switch-mobile-label");
const surgerySliderEl = document.getElementById("surgery");
const storeSliderEl = document.getElementById("store");
const storeNumberPlaceholderEls = document.querySelectorAll("[data-id=storeNumberPaceholder]");
const storePricePlaceholderEls = document.querySelectorAll("[data-id=storePricePaceholder]");
const surgeryNumberPlaceholderEls = document.querySelectorAll("[data-id=surgeryNumberPaceholder]");
const surgeryPricePlaceholderEls = document.querySelectorAll("[data-id=surgeryPricePaceholder]");
const surgeriesLabelEl = document.querySelector("label[for='surgeries']");
const storesLabelEl = document.querySelector("label[for='stores']")

const totalMonthPriceWithVatEls = document.getElementsByClassName("totalMonthPriceWithVat");
const totalYearPriceWithVatEls = document.getElementsByClassName("totalYearPriceWithVat");
const tarifLabelEls = document.querySelectorAll("[data-id=tarifLabelPlaceholder]");
const tarifPricePlaceholderEls = document.querySelectorAll("[data-id=tarifPricePlaceholder]");

const singlePaymentEls = document.querySelectorAll(".order-content [data-single-payment]");

const surgeryWithPlural = surgeriesLabelEl ? surgeriesLabelEl.dataset.tokens.split("|") : null;
const warehouseWithPlural = storesLabelEl ? storesLabelEl.dataset.tokens.split("|") : null;

export function order() {
    surgerySliderEl.addEventListener("input", function () {
        changePrices();
    });

    storeSliderEl.addEventListener("input", function () {
        changePrices();
    });

    frequencyEls.forEach(el => {
        el.addEventListener("change", function (e) {
            changePrices();

            if (el.value === "1") {
                singlePaymentEls.forEach(singlePaymentEl => {
                    singlePaymentEl.classList.add("display-none");
                });
            } else {
                singlePaymentEls.forEach(singlePaymentEl => {
                    singlePaymentEl.classList.remove("display-none");
                });
            }
        })
    });

    if (frequencyMobileCheckEl) {
        frequencyMobileCheckEl.addEventListener("click", function(e) {
            const disabledClass = "switch-mobile-label--disabled";
            const radioYearEl = document.querySelector("[data-label=radio-year]");
            radioYearEl.classList.toggle(disabledClass);

            const radioMonthEl = document.querySelector("[data-label=radio-month]");
            radioMonthEl.classList.toggle(disabledClass);

            document.querySelector("[name='frequency']").value = document.querySelector("[name='frequency']").value === "1"
                ? "0"
                : "1";

            changePrices();
        });
    }

    switchMobileLabelEls.forEach(el => {
        el.addEventListener("click", () => {
            frequencyMobileCheckEl.click();
        });
    })

    changePrices();
}

function changePrices() {
    let totalMonthPriceWithVat = Price.getTotalMonthPriceWithVat(surgerySliderEl.value, storeSliderEl.value);
    for (let e of totalMonthPriceWithVatEls) {
        Price.showPrice(e, totalMonthPriceWithVat);
    }
    let totalYearPriceWithVat = Price.getTotalYearPriceWithVat(surgerySliderEl.value, storeSliderEl.value);
    for (let e of totalYearPriceWithVatEls) {
        Price.showPrice(e, totalYearPriceWithVat);
    }

    //tarif
    for (let e of tarifLabelEls) {
        e.innerText = surgerySliderEl.value < 5 ? "Starter" : "Profi";
    }

    for (let e of tarifPricePlaceholderEls) {
        Price.showPrice(e, Price.getPriceWithVat(Price.getPriceWithDiscount(Price.getMonthTarifPrice(surgerySliderEl.value))));
    }

    //surgery
    for (let e of surgeryPricePlaceholderEls) {
        Price.showPrice(e, (surgerySliderEl.value - Price.getIncludedSurgeries(surgerySliderEl.value)) * Price.getPriceWithVat(Price.getPriceWithDiscount(Price.getMonthSurgeryPrice(surgerySliderEl.value))));
    }

    for (let e of surgeryNumberPlaceholderEls) {
        e.innerText = surgerySliderEl.value + " " + getPlural(surgerySliderEl.value, surgeryWithPlural);
    }

    //store
    for (let e of storePricePlaceholderEls) {
        Price.showPrice(e, (storeSliderEl.value - Price.includedStores) * Price.getPriceWithVat(Price.getPriceWithDiscount(Price.getMonthStorePrice())));
    }

    for (let e of storeNumberPlaceholderEls) {
        e.innerText = storeSliderEl.value + " " + getPlural(storeSliderEl.value, warehouseWithPlural);
    }
}

function getPlural(num, variants) {
    if (num == 1) {
        return variants[0];
    } else if (num > 1 && num < 5) {
        return variants[1];
    } else {
        return variants[2];
    }
}
